export class CustomerMessage {
  firstName: string
  lastName: string
  phoneNumber: string
  email: string
  addressLine1: string
  addressLine2: string
  city: string
  stateId?: number
  postalCode: string

  constructor(
    firstName: string,
    lastName: string,
    phoneNumber: string,
    email: string,
    addressLine1: string,
    addressLine2: string,
    city: string,
    stateId: number|undefined,
    postalCode: string) {
      this.firstName = firstName
      this.lastName = lastName
      this.phoneNumber = phoneNumber
      this.email = email
      this.addressLine1 = addressLine1
      this.addressLine2 = addressLine2
      this.city = city
      this.stateId = stateId
      this.postalCode = postalCode
  }
}
  